import { ImportStatus } from "../types/GenericImportTypes";

export class ImportMethodsUtils {
    static kb(n: number): string {
        return `${(n / 1024).toFixed(1)} KB`;
    }

    static statusToColor(s: ImportStatus): "green" | "red" | "orange" | "violet" {
        switch (s) {
            case "success":
                return "green";
            case "failed":
                return "red";
            case "partial":
                return "orange";
            default:
                return "violet";
        }
    }

    static summarizeErrors = (errs: string[]) =>
        errs.join(" | ");
}